export default {
  // Header
  header: {
    house: 'Σπίτι',
    activities: 'Δραστηριότητες', 
    beaches: 'Παραλίες',
    history: 'Ιστορία',
    cityGuide: 'Οδηγός πόλης',
    contact: 'Επικοινωνία',
    phone: '+30 6983446269'
  },

  // Hero Section
  hero: {
    title: 'Create your relax escape in Crete',
    bookNow: 'Κράτηση τώρα',
    phone: '+30 6983446269',
    airbnb: 'Airbnb',
    booking: 'Booking',
    yourRentals: 'YourRentals'
  },

  // House Section
  house: {
    title: 'Azure Loft',
    description: 'Ανακαλύψτε το Azure Loft, ένα γοητευτικό boho διαμέρισμα στην καρδιά της Κρήτης, σχεδιασμένο για απόλυτη χαλάρωση και άνεση. ',
    features: [
      ' Χώροι Διαμονής',
      '1 υπνοδωμάτιο σε παραδοσιακό ξύλινο οντά με άνετο διπλό κρεβάτι',
      'Τραπεζαρία με καναπέ-κρεβάτι, κατάλληλο για έναν επιπλέον επισκέπτη',
      'Άνετο σαλόνι με τηλεόραση και φωτεινή διακόσμηση',
      'Μπαλκόνι με τραπεζάκι και καρέκλες, ιδανικό για να απολαύσετε τη μοναδική θέα στη θάλασσα',
      'Πλήρως εξοπλισμένη κουζίνα με ψυγείο, air-fryer, εστίες, καφετιέρα και όλα τα απαραίτητα σκεύη',
      'Μπάνιο με ντους, σύγχρονα είδη υγιεινής και ζεστό νερό όλο το 24ωρο',
      ' Ανέσεις & Επιπλέον Παροχές',
      ' Κλιματισμός',
      'Πλυντήριο ρούχων και σίδερο',
      'Καθαρά λευκά είδη (σεντόνια, πετσέτες, μαξιλάρια)',
      'Τηλεόραση επίπεδης οθόνης',
      'Εύκολο πάρκινγκ κοντά στο κατάλυμα'
    ],
    bookNow: 'Κράτηση τώρα',
    rooms: {
      bedroom: 'Υπνοδωμάτιο 1',
      livingRoom: 'Σαλόνι',
      bedroom2: 'Υπνοδωμάτιο 2',
      kitchen: 'Κουζίνα',
      veranda: 'Βεράντα'
    },
    viewPhotos: 'Δείτε φωτογραφίες',
    closeGallery: 'Κλείσιμο'
  },

  // Top 5 Reasons
  reasons: {
    title: 'Οι 5 καλύτεροι λόγοι για να μείνετε στο Azure Loft',
    reason1: {
      title: '1. Θέα που σε καθηλώνει',
      description: 'Από το μπαλκόνι του Azure Loft αντικρίζεις ένα σκηνικό που μοιάζει με πίνακα ζωγραφικής: το απέραντο Κρητικό Πέλαγος, το λιμάνι του Ηρακλείου στο βάθος και τα χρώματα του ηλιοβασιλέματος που βάφουν τον ουρανό κάθε βράδυ. Ιδανικό για καφέ το πρωί και κρασί το βράδυ, με μοναδική αίσθηση γαλήνης.'
    },
    reason2: {
      title: '2. Η πόλη… μια ανάσα',
      description: 'Παρότι βρίσκεσαι σε ένα ήσυχο χωριό, το κέντρο του Ηρακλείου είναι μόλις 15-20 λεπτά μακριά. Εκεί θα βρεις ό,τι χρειαστείς: από μουσεία και αξιοθέατα μέχρι ζωντανή αγορά, εστιατόρια, μπαρ και πολιτιστικές εκδηλώσεις. Η πρόσβαση είναι εύκολη και ιδανική για ημερήσιες εξορμήσεις.'
    },
    reason3: {
      title: '3. Αυθεντική Κρήτη',
      description: 'Η Ροδιά είναι ένα από τα πιο όμορφα παραδοσιακά χωριά του Ηρακλείου. Χτισμένη σε λόφο με θέα θάλασσα και γεμάτη πετρόκτιστα σοκάκια, μικρές αυλές και παλιά σπίτια, προσφέρει αίσθηση αυθεντικότητας που σπανίζει. Είναι ένα μέρος όπου ο χρόνος κυλά πιο αργά – και αυτό είναι το μεγαλύτερο του προνόμιο.'
    },
    reason4: {
      title: '4. Κρυσταλλινές Παραλίες',
      description: 'Σε λιγότερο από 20 λεπτά οδήγησης από το Azure Loft, σας περιμένουν παραλίες για κάθε προτίμηση. Η Αμμουδάρα προσφέρει οργάνωση και ζωντάνια, η Λυγαριά είναι ιδανική για οικογένειες με καθαρά, ήρεμα νερά, ενώ η Αγία Πελαγία συνδυάζει όμορφο τοπίο με καλό φαγητό δίπλα στη θάλασσα. Για πιο ήσυχες στιγμές, προτιμήστε το Μαδέ ή τη γραφική Ψαρομούρα, με τα καταγάλανα νερά και την αυθεντική κρητική ατμόσφαιρα.'
    },
    reason5: {
      title: '5. Δίπλα στη γεύση της Κρήτης',
      description: 'Σε απόσταση αναπνοής από το Azure Loft, σε περιμένουν αυθεντικές κρητικές ταβέρνες με σπιτικά πιάτα, αγνά υλικά και τη φημισμένη φιλοξενία του νησιού. Εδώ θα απολαύσεις παραδοσιακές συνταγές, φρέσκα λαχανικά, ντόπιο κρασί και ρακή, σε ένα περιβάλλον ζεστό και φιλικό — ιδανικό για αξέχαστα γεύματα με αγαπημένα πρόσωπα.'
    }
    
  },

  // Reviews
  reviews: [
    {
      author: 'Gerasimos',
      date: 'πριν από 5 μήνες',
      rating: 5,
      text: 'Είχαμε μια εξαιρετική εμπειρία κατά τη διαμονή μας στο ενοικιαζόμενο σπίτι! Το κατάλυμα ήταν πεντακάθαρο, πλήρως εξοπλισμένο και πολύ άνετο. Η τοποθεσία του ήταν ιδανική, κοντά σε όλα όσα χρειαζόμασταν, αλλά ταυτόχρονα αρκετά ήσυχη για να απολαύσουμε την ηρεμία μας. Ο ιδιοκτήτης ήταν εξαιρετικά φιλικός και εξυπηρετικός, πάντα διαθέσιμος να μας βοηθήσει με οποιαδήποτε απορία ή ανάγκη προέκυπτε. Μας έδωσε και χρήσιμες συμβουλές για την περιοχή, όπως μέρη για φαγητό και δραστηριότητες. Το σπίτι είχε μοντέρνα διακόσμηση, άνετα κρεβάτια και ό,τι χρειαζόμασταν για να νιώσουμε σαν στο σπίτι μας. Το Wi-Fi ήταν γρήγορο και αξιόπιστο, κάτι που εκτιμήσαμε ιδιαίτερα. Συνολικά, μια φανταστική εμπειρία που θα συνιστούσα ανεπιφύλακτα σε οποιονδήποτε ψάχνει για ποιοτική διαμονή. Ανυπομονούμε να επιστρέψουμε!'
    },
    {
      author: 'Παπαδάκης Ιωάννης',
      date: 'πριν από 5 μήνες',
      rating: 5,
      text: 'Πραγματικά ένα πανέμορφο ζεστό σπίτι, με εκπληκτική θέα. Μείναμε στο Ηράκλειο για ένα μικρό διάστημα καθώς ο προορισμός μας ήταν νότια του Ρεθύμνου. Το πρώτο πράγμα που μας τράβηξε την προσοχή ήταν η θέα όταν κάναμε την κράτηση και όντως είναι απίστευτη. Επίσης το σπίτι είναι πάρα πολύ καθαρό και μύριζε όμορφα κάτι που είναι πολύ ευχάριστο όταν μπαίνεις στην βίλα για πρώτη φορά.'
    },
    {
      author: 'Panagiotis Chandroulidis',
      date: 'πριν από 1 μήνα',
      rating: 5,
      text: 'Ειναι υπέροχο με πανέμορφη θεα. Η ιδιοκτήτρια είναι φιλόξενη και πολύ ευγενική. Σας προτείνω να το επιλέξετε, είμαι σίγουρος θα απολαύσετε την διαμονή σας.'
    },
    {
      author: 'Βασιλης',
      date: '2 Μαρτίου 2025',
      rating: 5,
      text: 'Το σπίτι ήταν πολύ όμορφο και ιδανικό για ρομαντικές αποδράσεις. Ηλεκτρικά εξοπλισμένο και μπορούσαμε να μαγειρέψουμε😊 Η θέα το βράδυ φανταστική από το σπίτι μαζί με ένα κρασάκι το κάτι άλλο. Η οικοδέσποινα μας έστειλε αναλυτικές οδηγίες για το σπίτι. Αρκετά φιλική. Πολύ καλή εντύπωση γενικά.',
      source: 'booking'
    },
    {
      author: 'Σέβη Καλλέργη',
      date: '23 εβδομάδες πριν',
      rating: 5,
      text: 'Μαγευτική θέα και άνετος χώρος. Ήταν καθαρό και όλα στην εν τέλεια! Ήσυχα και ξεκούραστα. Θα ξαναπάω σίγουρα!'
    },
    {
      author: 'alex tevre',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Visiting Crete frequently, I can honestly say that this was one of the best apartments I\'ve ever stayed in! The amazing...'
    },
    {
      author: 'Ειρηνη Βρεντζου',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Πραγματικά υπέροχα.... Δεν έχω λόγια να περιγράψω την ομορφιά..όλα άψογα και προσεγμένα...το συστήνω ανεπιφύλακτα...'
    },
    {
      author: 'Αντωνης Αερακης',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Ήταν όλα τέλεια ! Υπεροχος και καθαρός χώρος με απίστευτη θέα !'
    },
    {
      author: 'Konstantina Orfanou',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Πολύ όμορφος χώρος και οι οικοδεσποτες φιλικοι, εξυπηρετικοί και πρόθυμοι να βοηθήσουν....'
    },
    {
      author: 'Πένυ Σταθογιαννοπούλου',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Υπέροχος χώρος με πολύ όμορφη αισθητική. Πεντακάθαρο και προσεγμένο μεχρι την τελευταία πινελιά! Το αγαπημένο μου μέρος...'
    },
    {
      author: 'MARIA IOANNA RESTIVAKI',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'If you\'re looking for a peaceful and scenic getaway, this holiday house in Rodia is an excellent choice!...'
    },
    {
      author: 'Μαρία Σταυρουλάκη',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Πολύ όμορφος ο χώρος και σε συνδυασμό με την απίστευτη θέα του Ηρακλείου έκανε την διαμονή μας αξέχαστη!!'
    },
    {
      author: 'βασιλης μαρης',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Σας δίνω τα συγχαρητήρια μου για το πόσο όμορφο και ανακαινισμένο είναι το σπίτι σας.Η διαμονή μας ήταν υπέροχη και το...'
    },
    {
      author: 'Μάνος Παπαδάκης',
      date: '24 εβδομάδες πριν',
      rating: 5,
      text: 'Πολύ ωραία θέα, ο ενοικιαστής πολύ εξυπηρετικός και ότι πρόβλημα είχα λυνόταν απευθείας το συνιστώ ανεπιφύλακτα για τις διακοπές σας είτε καλοκαιρινές είτε χειμερινές 😁'
    },
    {
      author: 'Panagiotis',
      date: '25 Ιουνίου 2025',
      rating: 5,
      text: 'Οι ιδιοκτήτρια και η διαχειρίστρια είναι υπέροχοι άνθρωποι, φιλόξενοι και ευγενικοί. Είχαμε μια τέλεια διαμονή και μια υπέροχη συνεργασία. Το σπίτι ηταν καθαρό και κατά την άφιξη μας μας περίμενε ενα ωραίο κέρασμα. Μα το Highlight ειναι το μπαλκόνι, η θέα είναι πανέμορφη, βλέπεις όλο το Ηράκλειο και το απέραντο γαλάζιο της θάλασσας.',
      source: 'booking'
    },
    {
      author: 'Lise',
      date: 'Μάιος 2025',
      rating: 3,
      text: 'Καλή τοποθεσία για να επισκεφτείτε την περιοχή του Ηρακλείου και κοντά στο αεροδρόμιο. Μικρό κατάλυμα για 4 άτομα (συμπεριλαμβανομένων των παιδιών, σπειροειδής σκάλα). Απαιτούνται ορισμένες βελτιώσεις...',
      source: 'airbnb'
    },
    {
      author: 'Εμμανουήλ',
      date: 'Απρίλιος 2025',
      rating: 5,
      text: 'Ήρεμο μέρος με ωραία θέα. Η επικοινωνία ήταν εξαιρετική.',
      source: 'airbnb'
    },
    {
      author: 'Εμμανουήλ',
      date: 'Μάρτιος 2025',
      rating: 5,
      text: 'Το σπίτι ήταν πολύ καθαρό και η θέα από το μπαλκόνι ήταν το κάτι άλλο και είχες όλες τις παροχές και η οικοδεσπότης πολύ φιλική και με βοήθησε σε ότι πρόβλημα και αν ειχα',
      source: 'airbnb'
    }
  ],

  // Reviews Section
  reviewsSection: {
    subtitle: 'Τι λένε οι επισκέπτες μας!',
    title: 'Κριτικές'
  },

  // Location Info
  location: {
    title: 'Η τοποθεσία μας',
    subtitle: 'Ένας γραφικός παράδεισος',
    description: 'Το Azure Loft βρίσκεται στη μαγευτική Ροδιά Ηρακλείου, έναν παραδοσιακό κρητικό οικισμό χτισμένο αμφιθεατρικά σε λόφο, με πανοραμική θέα στο Κρητικό Πέλαγος και την πόλη του Ηρακλείου. Η Ροδιά συνδυάζει αυθεντική φιλοξενία με μοναδική φυσική ομορφιά, ενώ αποτελεί ιδανικό σημείο εκκίνησης για εξερεύνηση τόσο της ενδοχώρας όσο και της βόρειας ακτογραμμής του νησιού.\n\nΣε κοντινή απόσταση μπορείτε να ανακαλύψετε κρυστάλλινα νερά, όπως το Παλαιόκαστρο, η Αμμουδάρα και το Λιμανάκι της Λυγαριάς, ιδανικές για μπάνιο, ηλιοθεραπεία και θαλάσσιες δραστηριότητες.\n\nΟι λάτρεις της ιστορίας και του πολιτισμού μπορούν εύκολα να επισκεφθούν το Αρχαιολογικό Μουσείο Ηρακλείου (18 χλμ), τα Ενετικά Τείχη (17 χλμ), καθώς και το παγκοσμίου φήμης Ανάκτορο της Κνωσού (21 χλμ). Για μια οικογενειακή εξόρμηση, το Cretaquarium – Θαλασσόκοσμος απέχει μόλις 33 χλμ και προσφέρει μία αξέχαστη εμπειρία για μικρούς και μεγάλους.\n\nΗ τοποθεσία του Azure Loft εξασφαλίζει εύκολη πρόσβαση στο Διεθνές Αεροδρόμιο Ηρακλείου (20 χλμ), ενώ το κατάλυμα διαθέτει και δωρεάν ιδιωτικό χώρο στάθμευσης, προσφέροντας άνεση στις μετακινήσεις σας.\n\nΑνακαλύψτε τη γοητεία της αυθεντικής Κρήτης, με φόντο τη θάλασσα και την ηρεμία του ημιορεινού τοπίου της Ροδιάς.'
  },

  // Calendar
  calendar: {
    title: 'Διαθεσιμότητα Azure Loft',
    close: 'Κλείσιμο',
    bookAirbnb: 'Κράτηση στο Airbnb',
    bookBooking: 'Κράτηση στο Booking',
    bookYourRentals: 'Κράτηση στο YourRentals',
    requestQuote: 'Ζητήστε Προσφορά'
  },

  // Footer
  footer: {
    generalInfo: 'Γενικές πληροφορίες',
    location: 'Τοποθεσία',
    getDirections: 'Πάρτε οδηγίες',
    contactWays: 'Τρόποι επικοινωνίας',
    faq: 'Τέλος ανθεκτικότητας',
    usefulLinks: 'Χρήσιμοι σύνδεσμοι',
    carRental: 'Ενοικίαση Αυτοκινήτου',
    busRoutes: 'Δρομολόγια Λεοφωρείων',
    cityGuide: 'Οδηγός πόλης',
    socialMedia: 'Social Media',
    newsletter: 'Ενημερωτικό Δελτίο',
    emailPlaceholder: 'Το email σας',
    signUp: 'Sign Me Up!',
    copyright: 'Πνευματικά δικαιώματα © AZURE LOFT GREECE 2025',
    manual: 'Εγχειρίδιο Σπιτιού'
  },

  contact: {
    title: 'Επικοινωνήστε μαζί μας',
    phone: 'ΤΗΛΕΦΩΝΟ',
    email: 'EMAIL',
    namePlaceholder: 'Εισάγετε το όνομά σας',
    emailPlaceholder: 'Εισάγετε μια έγκυρη διεύθυνση email',
    messagePlaceholder: 'Το μήνυμά σας',
    submit: 'ΥΠΟΒΟΛΗ',
    sending: 'Αποστολή...',
    success: 'Το μήνυμά σας στάλθηκε επιτυχώς!',
    error: 'Προέκυψε σφάλμα. Παρακαλώ δοκιμάστε ξανά.'
  },
  readMore: 'Διαβάστε περισσότερα',
  readLess: 'Διαβάστε λιγότερα'
}; 